import request from '@/utils/request'

/**
 * @param {import('@/types/generated/openapi').paths['/contact/list']['get']['parameters']['query']} params
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/contact/list']['get']['responses']['200']['content']['application/json']>>}
 */
export function getUserList(params) {
  return request({
    url: 'contact/list',
    method: 'get',
    params
  })
}

/**
 * 获取员工详情（含休假状态）
 * @param {string} username
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/contact/detail']['get']['responses']['200']['content']['application/json']>>}
 */
export function getContactDetail(username) {
  return request({
    url: 'contact/detail',
    method: 'get',
    params: { username }
  })
}

/**
 * 查询用户请假状态
 * @param {string} username
 * @returns {Promise<import('@/types/utils').R<{username: string, is_on_leave: boolean, leave_status: string, start_time: number, end_time: number}>>}
 */
export function getLeaveStatus(username) {
  return request({
    url: 'contact/leave-status',
    method: 'get',
    params: { username }
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/contact/sync']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/contact/sync']['post']['responses']['200']['content']['application/json']>>}
 */
export function syncDingtalk(data) {
  return request({
    url: 'contact/sync',
    method: 'post',
    data
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/contact/sync/record']['get']['parameters']['query']} params
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/contact/sync/record']['get']['responses']['200']['content']['application/json']>>}
 */
export function getSyncRecord(params) {
  return request({
    url: 'contact/sync/record',
    method: 'get',
    params
  })
}

/**
 * @param {{ username: string, role: string }} data
 * @returns {Promise<import('@/types/utils').R<any>>}
 */
export function updateUserRole(data) {
  return request({
    url: 'contact/role',
    method: 'put',
    data
  })
}

/**
 * 导出员工列表
 * @param {import('@/types/generated/openapi').paths['/contact/export']['get']['parameters']['query']} params
 * @returns {Promise<{response: Response, blob: Blob, filename: string}>}
 */
export function exportUserList(params) {
  return request({
    url: 'contact/export',
    method: 'get',
    params,
    responseType: 'blob'
  }).then(response => {
    const filename = response.headers['content-disposition']?.split('filename=')[1]
    const decodedFilename = filename ? decodeURIComponent(filename.replace(/\+/g, '%20')) : '员工列表.xlsx'
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    return { response, blob, filename: decodedFilename }
  })
}
